/* Copyright (c) 2017 Backpack Health LLC */

import { connect } from 'react-redux';

import { selectors as listSelectors } from '../../../redux/ducks/lists/lists';
import ProfileRace from './ProfileRace';
import { getActiveProfile, getActiveProfileId, getMainProfileId } from '../../redux/reduxSelectors';
import ProfileActions from '../../redux/ProfileActions';
import NavigationActions from '../../redux/NavigationActions';
import { actions as systemNotificationActions } from '../../../redux/ducks/systemNotification';
import { selectors as policySelectors } from '../../../redux/ducks/policy';
import { PolicyName } from '../../../../models/PolicyModel';

import RouteNames from '../../RouteNames';
import ProfileService from '../../../../apiServices/ProfileService';

function mapStateToProps(state, routerProps) {
  const races = listSelectors.getRaceCollection(state);
  const profile = getActiveProfile(state);

  return {
    races,
    requestInitialData: () => {},
    profile,
    policyIds: [policySelectors.getPolicyByName(state, PolicyName.RACE).id],
    isMainProfile: getActiveProfileId(state) === getMainProfileId(state),
    requestActiveProfile: () => {
      ProfileActions.api.getProfile(profile.data.id);
    },
    goBack: () => {
      NavigationActions.goBack(routerProps.history, RouteNames.profile());
    },

  };
}

function mapDispatchToProps(dispatch) {
  return {
    updateProfile: (profileData, callback) => {
      ProfileActions.api.updateProfile(profileData, (apiError) => {
        if (apiError) {
          dispatch(systemNotificationActions.showNotification());
          this.props.showNotification(apiError.messageKey());
        } else {
          ProfileActions.api.getProfile(profileData.id);
        }
        callback(apiError);
      });
    },
    clearViewErrors: () => {
      dispatch(systemNotificationActions.dismissNotification());
    },
    onWithdrawConsent: (profileId, policyIds: number[]) => {
      ProfileService.withdrawConsent(profileId, policyIds);
    },
    onProvideConsent: (profileId, policyIds: number[]) => {
      ProfileService.provideConsent(profileId, policyIds);
    },
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ProfileRace);
